import SvgIcon from '@mui/material/SvgIcon';

import type { SvgIconProps } from '@mui/material/SvgIcon';

const SeasonalChartIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      fontSize='inherit'
      viewBox='0 0 12 12'
    >
      <path
        d='M0 11.25H12V12H0V11.25Z'
        fill='currentColor'
      />
      <path
        d='M0 0H0.75V12H0V0ZM6.75 6L4.575 3.75L1.5 6.75V10.5H12V0.675L6.75 6Z'
        fill='currentColor'
      />
    </SvgIcon>
  );
};

export default SeasonalChartIcon;
